var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2292.35 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00bbf4;}.cls-2{fill:url(#radial-gradient);}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#radial-gradient-2);}.cls-7{fill:#333;}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#New_Gradient_Swatch_4);}.cls-10{fill:url(#New_Gradient_Swatch_5);}.cls-11{fill:url(#New_Gradient_Swatch_2);}.cls-12{fill:url(#New_Gradient_Swatch_4-2);}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#New_Gradient_Swatch_1);}.cls-15{fill:url(#New_Gradient_Swatch_4-3);}.cls-16{fill:url(#New_Gradient_Swatch_5-2);}.cls-17{fill:url(#New_Gradient_Swatch_1-2);}.cls-18{fill:url(#New_Gradient_Swatch_4-4);}.cls-19{fill:url(#New_Gradient_Swatch_5-3);}.cls-20{fill:url(#New_Gradient_Swatch_1-3);}.cls-21{fill:url(#New_Gradient_Swatch_4-5);}.cls-22{fill:url(#New_Gradient_Swatch_5-4);}.cls-23{fill:#10b9e9;}.cls-24{fill:#999;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 250.86,
    cy: 298.3,
    r: 234.24,
    gradientTransform: "translate(16.76 -380.06) scale(0.97 2.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2ad2ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2ad0fc",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#29c9f4",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#27bde5",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#25abd0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2295b4",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1f7a93",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d697e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 260.55,
    y1: 460,
    x2: 260.55,
    y2: 136.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ad2ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#239dbe",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#111010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 260.55,
    y1: 472.78,
    x2: 260.55,
    y2: 149.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a5b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0d6681",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1687a8",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1da3c8",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#23b8e0",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#27c7f2",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#29cffc",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ad2ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 179.7,
    y1: 371.07,
    x2: 341.4,
    y2: 371.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a67c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9f754c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8d633a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#754c24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 273.33,
    cy: 372.13,
    fx: 246.6203157620988,
    fy: 388.6168082725235,
    r: 157.1,
    gradientTransform: "translate(0 -52.62) scale(1 1.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#a67c52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 105.48,
    y1: 112.5,
    x2: 225.55,
    y2: 112.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 158.02,
    y1: 170,
    x2: 158.02,
    y2: 225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e99c00",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ad5d07",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#560210",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 165.55,
    x2: 165.55,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 295.55,
    y1: 112.5,
    x2: 415.63,
    y2: 112.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 363.09,
    y1: 170,
    x2: 363.09,
    y2: 225,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 355.55,
    x2: 355.55,
    y2: 170,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    y1: 120,
    x2: 145.55,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#560210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#862e32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#993f3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 52.84,
    y1: 170,
    x2: 52.84,
    y2: 240,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    x1: 73.05,
    x2: 73.05,
    y2: 170,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 209.93,
    y1: 120,
    x2: 311.18,
    y2: 120,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 260.55,
    y1: 170,
    x2: 260.55,
    y2: 240,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-3",
    x1: 260.55,
    x2: 260.55,
    y2: 170,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: 375.55,
    y1: 120,
    x2: 521.11,
    y2: 120,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-5",
    x1: 468.27,
    y1: 170,
    x2: 468.27,
    y2: 240,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-4",
    x1: 448.05,
    x2: 448.05,
    y2: 170,
    xlinkHref: "#New_Gradient_Swatch_5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_copy_12",
    "data-name": "logo copy 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.55,136.6V413.8c0,16.33-10.47,46.2-41.9,46.2H82.46C51,460,40.55,430.13,40.55,413.8V136.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "side_shadow",
    "data-name": "side shadow",
    className: "cls-2",
    d: "M480.55,136.6V413.8c0,16.33-10.47,46.2-41.9,46.2H82.46C51,460,40.55,430.13,40.55,413.8V136.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "top_shadow",
    "data-name": "top shadow",
    className: "cls-3",
    d: "M480.55,136.6V413.8c0,16.33-10.47,46.2-41.9,46.2H82.46C51,460,40.55,430.13,40.55,413.8V136.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottom_shadow",
    "data-name": "bottom shadow",
    className: "cls-4",
    d: "M480.55,136.6V413.8c0,16.33-10.47,46.2-41.9,46.2H82.46C51,460,40.55,430.13,40.55,413.8V136.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "door",
    className: "cls-5",
    d: "M341.4,460V333c0-25.41,0-50.82-40.42-50.82H220.13c-40.43,0-40.43,25.41-40.43,50.82V460Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "door-2",
    "data-name": "door",
    className: "cls-6",
    d: "M341.4,460V333c0-25.41,0-50.82-40.42-50.82H220.13c-40.43,0-40.43,25.41-40.43,50.82V460Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 306.55,
    cy: 383.19,
    r: 12.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth",
    className: "cls-8",
    d: "M105.55,170s-4.42,55,55,55c50,0,50-55,50-55l15-170h-80Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth_yellow",
    className: "cls-9",
    d: "M105.55,170s-4.42,55,55,55c50,0,50-55,50-55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "cloth_white",
    className: "cls-10",
    points: "105.55 170 210.55 170 225.55 0 145.55 0 105.55 170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth-2",
    "data-name": "cloth",
    className: "cls-11",
    d: "M310.55,170s0,55,50,55c59.43,0,55-55,55-55l-40-170h-80Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth_yellow-2",
    "data-name": "cloth_yellow",
    className: "cls-12",
    d: "M310.55,170s0,55,50,55c59.43,0,55-55,55-55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "cloth_white-2",
    "data-name": "cloth_white",
    className: "cls-13",
    points: "310.55 170 415.55 170 375.55 0 295.55 0 310.55 170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth-3",
    "data-name": "cloth",
    className: "cls-14",
    d: "M.55,170s-10,70,55,70c55,0,50-70,50-70l40-170h-55C50.55,0,.55,170,.55,170Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth_yellow-3",
    "data-name": "cloth_yellow",
    className: "cls-15",
    d: "M.55,170s-10,70,55,70c55,0,50-70,50-70Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth_white-3",
    "data-name": "cloth_white",
    className: "cls-16",
    d: "M.55,170h105l40-170h-55C50.55,0,.55,170,.55,170Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth-4",
    "data-name": "cloth",
    className: "cls-17",
    d: "M210.55,170s-10,70,50,70,50-70,50-70l-15-170h-70Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth_yellow-4",
    "data-name": "cloth_yellow",
    className: "cls-18",
    d: "M210.55,170s-10,70,50,70,50-70,50-70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "cloth_white-4",
    "data-name": "cloth_white",
    className: "cls-19",
    points: "210.55 170 310.55 170 295.55 0 225.55 0 210.55 170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth-5",
    "data-name": "cloth",
    className: "cls-20",
    d: "M415.55,170s-5,70,50,70c65,0,55-70,55-70s-50-170-90-170h-55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth_yellow-5",
    "data-name": "cloth_yellow",
    className: "cls-21",
    d: "M415.55,170s-5,70,50,70c65,0,55-70,55-70Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloth_white-5",
    "data-name": "cloth_white",
    className: "cls-22",
    d: "M415.55,170h105s-50-170-90-170h-55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.12,348.66q0,50.5,2.3,69.25Q849.22,431.68,818,443T757.4,454.26q-55.47,0-93.35-37.11t-37.88-96.23q0-59.1,41.32-101.38t102.92-42.28q54.71,0,101.39,33.67-16.45,18-48.21,36-11.87-16.06-32.52-27.16t-41.89-11.1q-21.24,0-29.65,2.3-35.6,30.62-35.59,98.32,0,55.49,20.28,83.6T770.79,421q23.34,0,41.71-6.12,5.34-27.92,5.35-65H767l19.51-30.61q36.74,2.69,62.36,2.68t42.47-.77l-13.39,27.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.82,454.64q-39,0-52.61-16.64t-13.58-54.14V338.33q0-37.87-11.48-63.89V266h66.57v9.18Q982,295.11,982,326.85v50.89q0,19.14,6.51,29.65t18.36,10.52q20.28,0,48.21-19.51V338.33q0-38.64-11.1-63.89V266h66.19v9.18q-5.73,19.91-5.74,51.65v50.89a104.66,104.66,0,0,0,5.55,33.67q5.55,16.45,13.2,22.95l1.15,8.42-60.07,15.3a69.94,69.94,0,0,1-9.18-31Q1022.15,454.65,998.82,454.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223,456.55A66.48,66.48,0,0,1,1180.55,442q-18.36-14.53-18.36-42.08,0-53.18,77.66-53.18l34.05,1.53V324.94q0-19.89-9.94-32.14t-30.61-12.24q-4.59,0-11.86,4.78a78.06,78.06,0,0,0-12.25,9.76Q1193.55,310,1184,319.58q-19.12-22.56-20.66-45.52,49-15.3,82.64-15.31t56.24,15.69q22.57,15.69,22.58,49.35v60.07a94.86,94.86,0,0,0,5.74,32.9q5.73,15.71,14.15,21.05l.77,8.41-54.71,11.48q-6.13-11.47-11.48-32.14a198.45,198.45,0,0,1-16.07,15.88q-6.12,5.16-17,10.14A55.23,55.23,0,0,1,1223,456.55Zm51.27-83.4a89.21,89.21,0,0,0-30.42-5q-16.65,0-25.44,6.13-5.75,7.26-5.74,19.13,0,29.83,26,29.84,21.43,0,35.59-17.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508,258.75q36.35,0,48.21,32.14,12.63-10.33,20.47-16.07a103.43,103.43,0,0,1,19.7-10.9,56.48,56.48,0,0,1,22.58-5.17q28.7,0,44.38,17.79T1679.06,328v52.42q0,34.05,11.48,60.83v8.42h-67.33v-8.42q6.49-18,6.5-49v-50.5q0-21.81-5.36-32.53T1602,298.54q-17,0-40.74,13.39.75,10,.76,16.07v52.42q0,34.05,11.48,60.83v8.42H1510v-8.42q6.49-18,6.5-49v-50.5q0-21.81-5-32.53t-20.85-10.71q-15.89,0-42.28,16.07v66.57q0,36.36,11.1,60.07v8.42h-67v-8.42q6.51-19.51,6.51-51.65V333q0-42.86-23-54.33v-8.42l62-11.86,3.83,7.27q3,7.65,4.59,24.49,18-16.08,31.56-23.73A60.24,60.24,0,0,1,1508,258.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1798.43,172.67q-1.53,18.36-1.53,43.61t.38,31V385.77q0,35.58,6.12,55.48l.38,8.42h-62v-8.42q6.12-19.89,6.13-55.48V235.41q0-32.9-17.22-49.35v-8.42l63.13-13.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1915.5,299.31v81.87q0,36.36,11.1,60.07v8.42h-67v-8.42q6.51-19.51,6.51-51.65V333q0-21-6.51-35t-16.45-19.32v-8.42l70-13,4.59,7.65Q1915.51,273.68,1915.5,299.31Zm-7.27-124q3.45,3.06,4.78,13a122.1,122.1,0,0,1,1.34,15.3,53.77,53.77,0,0,1-.76,9.56l-3.45,3.06q-16.83,5-44,6.89l-4.21-1.91q-3.07-5-4.78-16.45a128,128,0,0,1-1.73-15.88V183l3.45-3.06a128.84,128.84,0,0,1,40.93-6.89H1904Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2050.94,424.8q21.81,0,21.8-21,0-19.51-37.11-29.46-15.3-4.21-30.6-9.57a62.07,62.07,0,0,1-26-17.22q-10.71-11.85-10.71-30.22,0-26.4,23.72-41.13t57.77-14.73q34,0,71.16,16.45-1.92,16.85-20.66,40.56-15.3-15.3-31.75-23.34t-28.7-8q-12.24,0-18.75,2.68-5.73,5-5.73,16.26t10.9,17.41q10.9,6.12,26.59,9.76a322.08,322.08,0,0,1,31.37,9,59.67,59.67,0,0,1,26.59,18.17q10.91,12.82,10.91,33.48,0,29.83-23.15,44.95t-61.41,15.12q-38.25,0-73.07-21.81,1.52-23,17.21-42.47Q2019.19,424.8,2050.94,424.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2232.29,405.29q0,13.77,7.26,13.77,10.34,0,38.65-11.86l11.47,17.22a295,295,0,0,1-36.34,19.7q-21,9.75-36.73,9.76-33.67,0-33.67-38.65V293.57q-5.74,0-37.88,2.68l13.78-34.44q6.89,1.15,24.48,1.92-.76-17.6-2.29-32.52l51.27-13v45.14q15.28-.37,60.06-5l-14.92,39.41a316.25,316.25,0,0,0-45.14-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M704.88,40.32h10.9v79.35H704.43V60.24l.57,3.49-20.43,44.91h-8.1L656.05,64.82l.57-4.58v59.43H645.27V40.32h10.89l24.36,52.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M737.74,116.15q-5.41-4.35-5.42-13.18,0-8.41,5-12.61t15-4.2h16.83l.8,9H752.35c-3.05,0-5.32.64-6.82,1.94s-2.25,3.26-2.25,5.92c0,2.87,1,5,3,6.38s5,2.08,9.1,2.08q6.68,0,10-1.37t3.28-4.26l1.2,8a13.21,13.21,0,0,1-3.79,3.77,16.88,16.88,0,0,1-5.22,2.21,27.81,27.81,0,0,1-6.68.74Q743.16,120.49,737.74,116.15ZM768.6,83.76c0-3.71-1-6.6-3.1-8.65s-5-3.09-8.82-3.09a23.61,23.61,0,0,0-6.93,1,21.13,21.13,0,0,0-6,2.89l-8.5-5.56a22.12,22.12,0,0,1,8.87-6,33.25,33.25,0,0,1,12.24-2.16A29.36,29.36,0,0,1,769,64.68a17.69,17.69,0,0,1,8,7.21,22.25,22.25,0,0,1,2.74,11.38v36.4H768.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M805,118a17.29,17.29,0,0,1-7-7.89,29.4,29.4,0,0,1-2.4-12.44V85.12A30.28,30.28,0,0,1,798,72.62a17.15,17.15,0,0,1,6.82-7.88A20.45,20.45,0,0,1,815.55,62a18.4,18.4,0,0,1,9.62,2.61,19.74,19.74,0,0,1,7,7.37L831,83.59a12.83,12.83,0,0,0-1.37-6.16,9.17,9.17,0,0,0-4-3.91,13.64,13.64,0,0,0-6.3-1.33q-5.77,0-8.93,3.43t-3.17,9.66V97.62q0,6.16,3.17,9.52t8.93,3.36a13.27,13.27,0,0,0,6.3-1.39,9.4,9.4,0,0,0,4-4A13.32,13.32,0,0,0,831,98.82l.8,12a16.27,16.27,0,0,1-5.79,7,16.75,16.75,0,0,1-9.9,2.84A21.52,21.52,0,0,1,805,118Zm26-77.63h11.64v79.35H831Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M870.55,117.54a20.15,20.15,0,0,1-8.87-8.65,28.8,28.8,0,0,1-3-13.78V88.72a32.13,32.13,0,0,1,2.93-14.35,20.4,20.4,0,0,1,8.53-9.06,27.36,27.36,0,0,1,13.46-3.11A21,21,0,0,1,904.23,76,42,42,0,0,1,907,92.11v3.71H867.07V86.87h28.86q-.51-6.93-3.73-10.78a10.69,10.69,0,0,0-8.65-3.85q-6.62,0-10.24,4.15c-2.41,2.76-3.62,6.68-3.62,11.73v7.21q0,7,3.88,10.8t11,3.77a19.1,19.1,0,0,0,7-1.37,20.38,20.38,0,0,0,6.22-3.82l7.64,7.32a32.59,32.59,0,0,1-9.87,6.25,29.27,29.27,0,0,1-11,2.21A30.83,30.83,0,0,1,870.55,117.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M963.88,117.59a19.5,19.5,0,0,1-8.36-8.43,28.6,28.6,0,0,1-2.88-13.34V86.59a28,28,0,0,1,2.88-13.18,19.43,19.43,0,0,1,8.36-8.35,31.78,31.78,0,0,1,26.35,0,19.43,19.43,0,0,1,8.36,8.35,28,28,0,0,1,2.88,13.18V96a28.17,28.17,0,0,1-2.88,13.24,19.58,19.58,0,0,1-8.36,8.37,31.38,31.38,0,0,1-26.35,0Zm22.62-11.35q3.33-3.66,3.33-10.26V86.59q0-6.6-3.33-10.2t-9.45-3.6q-6.09,0-9.44,3.6t-3.33,10.2V96q0,6.6,3.33,10.26t9.44,3.66Q983.16,109.9,986.5,106.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1018,63h11.63v56.65H1018ZM1054,85.34q0-6-3.26-9.28c-2.16-2.18-5.21-3.27-9.12-3.27s-6.75,1-8.82,2.89-3.11,4.64-3.11,8.13l-1.19-10.91a20.56,20.56,0,0,1,7.15-7.92,18.05,18.05,0,0,1,9.79-2.78q9.63,0,14.92,6t5.27,17v34.39H1054Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1114.65,40.32h11.64V51.45h-11.64Zm0,22.7h11.64v56.65h-11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1155.07,119.5a36.5,36.5,0,0,1-8.58-2.94,33.32,33.32,0,0,1-7.36-4.92l6.9-8.13a39.13,39.13,0,0,0,9.53,5.24,26.72,26.72,0,0,0,9.35,1.75q6.9,0,10.36-2a6.68,6.68,0,0,0,3.45-6.14,4.71,4.71,0,0,0-1.89-4.09,10.85,10.85,0,0,0-4.67-1.83c-1.87-.31-4.49-.59-7.88-.85-.3,0-.62,0-1,0l-1-.08a3.4,3.4,0,0,1-.45,0,3.55,3.55,0,0,0-.46,0,48,48,0,0,1-9.75-1.61,13.22,13.22,0,0,1-6.65-4.39c-1.77-2.15-2.65-5.22-2.65-9.23a18,18,0,0,1,2.57-10,15.43,15.43,0,0,1,7.64-6,35,35,0,0,1,12.72-2,45.69,45.69,0,0,1,8.82.82,40.1,40.1,0,0,1,15.37,6.49l-7,8.13a39.65,39.65,0,0,0-8.75-4.09,27.83,27.83,0,0,0-8.42-1.36q-5.93,0-8.9,1.93a6.48,6.48,0,0,0-3,5.82,3.88,3.88,0,0,0,1.68,3.43,10,10,0,0,0,4.25,1.53q2.56.39,7.3.66a5.52,5.52,0,0,0,.71,0,5.09,5.09,0,0,1,.77.06h.35a1.4,1.4,0,0,1,.34,0,53.09,53.09,0,0,1,10.58,1.58,14.35,14.35,0,0,1,7.33,4.75q3,3.56,3,10.26a17.63,17.63,0,0,1-2.74,10.13,16.51,16.51,0,0,1-8.24,6,40.8,40.8,0,0,1-13.84,2A46.62,46.62,0,0,1,1155.07,119.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1216.2,105a4.8,4.8,0,0,0,.94,3.19,3.26,3.26,0,0,0,2.65,1.12h5.48v10.59h-6.85q-6.62,0-10.24-3.93t-3.62-11.08V40.32h11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1240.38,116.15Q1235,111.8,1235,103q0-8.41,5-12.61t15-4.2h16.83l.8,9H1255c-3,0-5.32.64-6.82,1.94s-2.25,3.26-2.25,5.92a7.24,7.24,0,0,0,3,6.38q3,2.09,9.1,2.08,6.67,0,10-1.37c2.18-.91,3.28-2.33,3.28-4.26l1.2,8a13.37,13.37,0,0,1-3.8,3.77,16.88,16.88,0,0,1-5.22,2.21,27.78,27.78,0,0,1-6.67.74Q1245.81,120.49,1240.38,116.15Zm30.87-32.39c0-3.71-1-6.6-3.11-8.65s-5-3.09-8.81-3.09a23.72,23.72,0,0,0-6.94,1,20.94,20.94,0,0,0-6,2.89l-8.5-5.56a22,22,0,0,1,8.87-6A33.2,33.2,0,0,1,1259,62.2a29.36,29.36,0,0,1,12.61,2.48,17.76,17.76,0,0,1,8,7.21,22.35,22.35,0,0,1,2.73,11.38v36.4h-11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1300,63h11.64v56.65H1300Zm35.94,22.32q0-6-3.25-9.28t-9.13-3.27q-5.7,0-8.81,2.89c-2.08,1.93-3.11,4.64-3.11,8.13l-1.2-10.91A20.5,20.5,0,0,1,1317.6,65a18,18,0,0,1,9.78-2.78q9.64,0,14.92,6t5.28,17v34.39h-11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1372.93,118a17.21,17.21,0,0,1-7-7.89,29.4,29.4,0,0,1-2.4-12.44V85.12a30.28,30.28,0,0,1,2.34-12.5,17.15,17.15,0,0,1,6.82-7.88,20.43,20.43,0,0,1,10.75-2.7,18.37,18.37,0,0,1,9.61,2.61,19.76,19.76,0,0,1,7,7.37l-1.2,11.57a12.94,12.94,0,0,0-1.37-6.16,9.14,9.14,0,0,0-4-3.91,13.64,13.64,0,0,0-6.3-1.33q-5.76,0-8.93,3.43t-3.16,9.66V97.62q0,6.16,3.16,9.52t8.93,3.36a13.27,13.27,0,0,0,6.3-1.39,9.37,9.37,0,0,0,4-4,13.44,13.44,0,0,0,1.37-6.28l.8,12a16.27,16.27,0,0,1-5.79,7,16.75,16.75,0,0,1-9.9,2.84A21.55,21.55,0,0,1,1372.93,118Zm26-77.63h11.64v79.35h-11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1426.24,108h12.21v17.68l-12.21,12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1486.09,63h11.63v56.65h-11.63Zm35.37,22.32q0-6-3.08-9.28t-8.73-3.27c-3.81,0-6.74,1-8.82,2.89s-3.11,4.64-3.11,8.13l-1.19-10.91a20.5,20.5,0,0,1,7.16-7.92,18,18,0,0,1,9.78-2.78,19.89,19.89,0,0,1,10.61,2.7,17.12,17.12,0,0,1,6.7,7.89,30.54,30.54,0,0,1,2.31,12.49v34.39h-11.63Zm35.37,0q0-6-3.26-9.28c-2.16-2.18-5.21-3.27-9.12-3.27-3.62,0-6.41,1-8.39,3.16s-3,5.1-3,9L1530.75,74a22.09,22.09,0,0,1,7.39-8.71,17.83,17.83,0,0,1,10.13-3.08,21,21,0,0,1,10.92,2.7,17.19,17.19,0,0,1,6.91,7.89,30,30,0,0,1,2.36,12.49v34.39h-11.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1588.71,116.15q-5.42-4.35-5.41-13.18,0-8.41,5-12.61t15-4.2h16.83l.8,9h-17.57c-3,0-5.32.64-6.82,1.94s-2.25,3.26-2.25,5.92a7.24,7.24,0,0,0,3,6.38q3,2.09,9.1,2.08,6.67,0,10-1.37c2.18-.91,3.28-2.33,3.28-4.26l1.2,8a13.37,13.37,0,0,1-3.8,3.77,16.88,16.88,0,0,1-5.22,2.21,27.78,27.78,0,0,1-6.67.74Q1594.14,120.49,1588.71,116.15Zm30.87-32.39c0-3.71-1-6.6-3.11-8.65s-5-3.09-8.81-3.09a23.72,23.72,0,0,0-6.94,1,20.94,20.94,0,0,0-6,2.89l-8.5-5.56a22,22,0,0,1,8.87-6,33.2,33.2,0,0,1,12.23-2.16,29.36,29.36,0,0,1,12.61,2.48,17.76,17.76,0,0,1,8,7.21,22.35,22.35,0,0,1,2.73,11.38v36.4h-11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1656,118a17.29,17.29,0,0,1-7-7.89,29.56,29.56,0,0,1-2.39-12.44V85.12a30.28,30.28,0,0,1,2.34-12.5,17.19,17.19,0,0,1,6.81-7.88,20.46,20.46,0,0,1,10.76-2.7,18.37,18.37,0,0,1,9.61,2.61,19.66,19.66,0,0,1,7,7.37L1682,83.59a12.94,12.94,0,0,0-1.37-6.16,9.2,9.2,0,0,0-4-3.91,13.64,13.64,0,0,0-6.3-1.33q-5.76,0-8.93,3.43t-3.17,9.66V97.62q0,6.16,3.17,9.52t8.93,3.36a13.27,13.27,0,0,0,6.3-1.39,9.42,9.42,0,0,0,4-4,13.44,13.44,0,0,0,1.37-6.28l.8,12a16.27,16.27,0,0,1-5.79,7,16.79,16.79,0,0,1-9.9,2.84A21.53,21.53,0,0,1,1656,118Zm26-77.63h11.63v79.35H1682Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1721.52,117.54a20.15,20.15,0,0,1-8.87-8.65,28.92,28.92,0,0,1-3.05-13.78V88.72a32.13,32.13,0,0,1,2.94-14.35,20.38,20.38,0,0,1,8.52-9.06,27.37,27.37,0,0,1,13.47-3.11A21,21,0,0,1,1755.21,76a42.25,42.25,0,0,1,2.76,16.1v3.71H1718V86.87h28.87q-.53-6.93-3.74-10.78a10.69,10.69,0,0,0-8.64-3.85q-6.62,0-10.24,4.15c-2.42,2.76-3.62,6.68-3.62,11.73v7.21q0,7,3.87,10.8t11,3.77a19.1,19.1,0,0,0,7-1.37,20.38,20.38,0,0,0,6.22-3.82l7.64,7.32a32.46,32.46,0,0,1-9.87,6.25,29.27,29.27,0,0,1-11,2.21A30.83,30.83,0,0,1,1721.52,117.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1800.76,63h29.61v9.49h-29.61Zm6.27-7.7q0-7.53,3.63-11.27t11.15-3.73h8.56V50.9H1822a2.88,2.88,0,0,0-2.51,1.2,5.25,5.25,0,0,0-.86,3.11v64.46H1807Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1850.16,117.59a19.5,19.5,0,0,1-8.36-8.43,28.6,28.6,0,0,1-2.88-13.34V86.59a28,28,0,0,1,2.88-13.18,19.43,19.43,0,0,1,8.36-8.35,31.8,31.8,0,0,1,26.36,0,19.48,19.48,0,0,1,8.36,8.35,28,28,0,0,1,2.88,13.18V96a28.17,28.17,0,0,1-2.88,13.24,19.63,19.63,0,0,1-8.36,8.37,31.4,31.4,0,0,1-26.36,0Zm22.62-11.35q3.35-3.66,3.34-10.26V86.59q0-6.6-3.34-10.2t-9.44-3.6q-6.1,0-9.44,3.6t-3.34,10.2V96q0,6.6,3.34,10.26t9.44,3.66Q1869.45,109.9,1872.78,106.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1904.3,63h11.64v56.65H1904.3ZM1933,73.71a14.79,14.79,0,0,0-5.42-.92c-3.68,0-6.55,1-8.58,2.92s-3,4.65-3,8.1l-1.2-10.91a21,21,0,0,1,7.07-7.89,17.3,17.3,0,0,1,9.59-2.81,22.51,22.51,0,0,1,7.33,1.12,16.39,16.39,0,0,1,5.73,3.3l-7.59,9.82A9.7,9.7,0,0,0,1933,73.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1985.54,40.32h11.63V51.45h-11.63Zm0,22.7h11.63v56.65h-11.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2026,119.5a36.5,36.5,0,0,1-8.58-2.94,33.55,33.55,0,0,1-7.36-4.92l6.9-8.13a39.31,39.31,0,0,0,9.53,5.24,26.72,26.72,0,0,0,9.35,1.75q6.9,0,10.36-2a6.68,6.68,0,0,0,3.45-6.14,4.73,4.73,0,0,0-1.88-4.09,11,11,0,0,0-4.68-1.83q-2.8-.47-7.87-.85c-.31,0-.63,0-1,0l-1-.08a3.44,3.44,0,0,1-.46,0,3.55,3.55,0,0,0-.46,0,48,48,0,0,1-9.75-1.61,13.26,13.26,0,0,1-6.65-4.39c-1.77-2.15-2.65-5.22-2.65-9.23a18.07,18.07,0,0,1,2.57-10,15.48,15.48,0,0,1,7.64-6,35.08,35.08,0,0,1,12.72-2A45.69,45.69,0,0,1,2045,63a40.1,40.1,0,0,1,15.37,6.49l-7,8.13a39.65,39.65,0,0,0-8.75-4.09,27.78,27.78,0,0,0-8.42-1.36q-5.93,0-8.9,1.93a6.51,6.51,0,0,0-3,5.82,3.88,3.88,0,0,0,1.68,3.43,10,10,0,0,0,4.25,1.53q2.57.39,7.3.66a5.55,5.55,0,0,0,.72,0,5.06,5.06,0,0,1,.76.06h.35a1.33,1.33,0,0,1,.34,0,53.09,53.09,0,0,1,10.58,1.58,14.35,14.35,0,0,1,7.33,4.75q3,3.56,3,10.26a17.55,17.55,0,0,1-2.74,10.13,16.51,16.51,0,0,1-8.24,6,40.76,40.76,0,0,1-13.84,2A46.62,46.62,0,0,1,2026,119.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2087.08,105a4.8,4.8,0,0,0,.94,3.19,3.26,3.26,0,0,0,2.65,1.12h5.48v10.59h-6.85q-6.62,0-10.24-3.93t-3.62-11.08V40.32h11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2111.27,116.15q-5.43-4.35-5.42-13.18,0-8.41,5-12.61t15-4.2h16.83l.8,9h-17.57c-3,0-5.31.64-6.82,1.94s-2.25,3.26-2.25,5.92a7.22,7.22,0,0,0,3,6.38q3,2.09,9.09,2.08,6.68,0,10-1.37t3.28-4.26l1.2,8a13.25,13.25,0,0,1-3.8,3.77,16.88,16.88,0,0,1-5.22,2.21,27.72,27.72,0,0,1-6.67.74Q2116.69,120.49,2111.27,116.15Zm30.86-32.39c0-3.71-1-6.6-3.11-8.65s-5-3.09-8.81-3.09a23.61,23.61,0,0,0-6.93,1,21,21,0,0,0-6,2.89l-8.5-5.56a22,22,0,0,1,8.87-6,33.24,33.24,0,0,1,12.23-2.16,29.36,29.36,0,0,1,12.61,2.48,17.76,17.76,0,0,1,8,7.21,22.35,22.35,0,0,1,2.74,11.38v36.4h-11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2170.88,63h11.64v56.65h-11.64Zm35.94,22.32q0-6-3.25-9.28t-9.13-3.27q-5.7,0-8.81,2.89c-2.08,1.93-3.11,4.64-3.11,8.13l-1.2-10.91a20.58,20.58,0,0,1,7.16-7.92,18,18,0,0,1,9.78-2.78q9.64,0,14.92,6t5.28,17v34.39h-11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2243.82,118a17.18,17.18,0,0,1-7-7.89,29.4,29.4,0,0,1-2.4-12.44V85.12a30.28,30.28,0,0,1,2.34-12.5,17.15,17.15,0,0,1,6.82-7.88,20.43,20.43,0,0,1,10.75-2.7,18.37,18.37,0,0,1,9.61,2.61A19.76,19.76,0,0,1,2271,72l-1.2,11.57a12.94,12.94,0,0,0-1.37-6.16,9.17,9.17,0,0,0-4-3.91,13.68,13.68,0,0,0-6.31-1.33q-5.76,0-8.92,3.43t-3.17,9.66V97.62q0,6.16,3.17,9.52t8.92,3.36a13.31,13.31,0,0,0,6.31-1.39,9.4,9.4,0,0,0,4-4,13.44,13.44,0,0,0,1.37-6.28l.8,12a16.27,16.27,0,0,1-5.79,7,16.75,16.75,0,0,1-9.9,2.84A21.52,21.52,0,0,1,2243.82,118Zm26-77.63h11.64v79.35H2269.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9a47f9a360be30b5be26947a13b4986a.svg";
export { ForwardRef as ReactComponent };